<template>
  <v-card class="clipped-large"
    tile>
    <v-toolbar :height="getHeight"
      :style="`--slot-toolbar-h: ${getHeight}px; cursor: pointer`"
      :color="titleColor"
      :extended="extended"
      extension-height="10"
      @click="empty ? '' : (detailDialog = true)">
      <div class="d-inline-flex ml-0"
        :class="mobile ? 'text-cc-overline' : 'heading h3 text-uppercase'">
        <slot name="header" />
      </div>
      <v-spacer />
      <v-toolbar-items v-if="!portrait"
        :class="mobile ? 'text-cc-overline' : 'heading h3 text-uppercase'">
        <slot name="header-items" />
      </v-toolbar-items>
      <template v-if="extended"
        #extension>
        <v-spacer />

        <slot name="extension" />
      </template>
    </v-toolbar>
    <div v-if="portrait"
      style="position: absolute; top: 12px; right: -4px">
      <slot name="header-items" />
    </div>

    <v-card-text class="px-2 pt-0 pb-2">
      <v-card v-if="item?.FlavorDescription"
        tile
        color="panel"
        class="px-2 py-1 mb-2 clipped">
        <p v-html-safe="item.FlavorDescription"
          style="white-space: pre-wrap" />
      </v-card>

      <slot />

      <equipment-details v-if="item"
        :item="item"
        :mech="mech"
        :color="color"
        :synergy-location="synergyLocation" />

      <div v-if="empty"
        class="py-3 text-center fade-select"
        style="height: 100%; cursor: pointer"
        @click="openSelector">
        <v-row style="height: 100%">
          <div class="heading h2 text-disabled my-auto py-5"
            style="width: 100%">
            // {{ mobile ? 'TAP' : 'CLICK' }} TO ADD //
          </div>
        </v-row>
      </div>
    </v-card-text>
  </v-card>

  <cc-solo-modal v-model="detailDialog"
    :title="item?.Name || ''"
    :icon="item?.Icon || ''"
    shrink>
    <cc-item-card :item="item"
      notes />
    <slot name="detail" />
  </cc-solo-modal>

  <cc-solo-modal v-model="selectorDialog"
    title="select equipment"
    clip
    @close="$emit('selector-close')">
    <slot name="selector" />
  </cc-solo-modal>
</template>

<script lang="ts">
import { ItemType } from '@/class'
import { useMobile } from '@/mixins/useMobile'
import EquipmentDetails from './_EquipmentDetails.vue'

export default {
  name: 'SlotCardBase',
  components: { EquipmentDetails },
  mixins: [useMobile],
  props: {
    item: {
      type: Object,
      required: false,
      default: null,
    },
    mech: {
      type: Object,
      required: true,
      default: null,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    titleColor: {
      type: String,
      required: false,
    },
    extended: {
      type: Boolean,
      default: false,
    },
    weapon: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selector-close', 'selector-open'],
  data: () => ({
    detailDialog: false,
    selectorDialog: false,
  }),
  computed: {
    synergyLocation() {
      if (!this.item) return 'none'
      return this.item.ItemType === ItemType.MechWeapon ? 'weapon' : 'system'
    },
    getHeight() {
      return this.mobile ? 18 : 20
    },
  },
  methods: {
    openSelector() {
      if (this.$slots.selector) {
        this.selectorDialog = true
        return
      }
      this.$emit('selector-open')
    },
  },
}
</script>

<style scoped>
:deep(.v-toolbar),
:deep(.v-toolbar__content) {
  height: auto !important;
  min-height: var(--slot-toolbar-h) !important;
}
</style>
